/* eslint-disable no-unused-expressions */
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  transit_stop_amenities: [],
  high_capacity_transit_facility: '',
  hct_amenities: [],
  vc: '',
  high_capacity_transit: '',
  transit_tier: '',
  land_use_context: '',
  scores: {}
}

const transit = createSlice({
  name: 'transit',
  initialState,
  reducers: {
    setTransitInputs(state, action) {
      const { field, value } = action.payload
      if (field === 'transit_stop_amenities' || field === 'hct_amenities') {
        // If filed already includes value remove it / add
        state[field] = state[field].includes(value)
          ? [...state[field]]
          : [...state[field], value]
      } else {
        state[field] = value
      }
    },
    removeTransitStopAmenitiesInput(state, action) {
      const { value } = action.payload

      // If filed  includes value remove it
      state.transit_stop_amenities = state.transit_stop_amenities.includes(
        value
      )
        ? state.transit_stop_amenities.filter((input) => input !== value)
        : [...state.transit_stop_amenities]
    },
    removeHCTAmenitiesInput(state, action) {
      const { value } = action.payload

      // If filed  includes value remove it
      state.hct_amenities = state.hct_amenities.includes(value)
        ? state.hct_amenities.filter((input) => input !== value)
        : [...state.hct_amenities]
    },
    clearAllHCTAmenities(state, action) {
      state.hct_amenities = []
    },
    setTransitScores(state, action) {
      const { field, value } = action.payload
      state.scores = { ...state.scores, [field]: value }
    },
    resetTransitInputs(state) {
      return initialState
    },
    setAllTransitInputs(state, action) {
      return action.payload
    }
  }
})

export const {
  setTransitInputs,
  setTransitScores,
  removeTransitStopAmenitiesInput,
  removeHCTAmenitiesInput,
  resetTransitInputs,
  setAllTransitInputs,
  clearAllHCTAmenities
} = transit.actions
export default transit.reducer
